const productSlider = new Swiper('.product-slider-grid', {
  slidesPerView: 2,
  slidesPerGroup: 2,
  spaceBetween: 10,
  loop: true,
  allowTouchMove: true,
  navigation: {
    prevEl: '.product-slider .swiper-button-prev',
    nextEl: '.product-slider .swiper-button-next',
  },
  pagination: {
    el: '.product-slider .swiper-pagination',
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 20,
      allowTouchMove: false,
    }
  }
});